import * as React from 'react';

import {
  AppBar,
  Toolbar,
  Typography,
  Box,
} from '@mui/material';

import SettingsIcon from '@mui/icons-material/Settings';
import {v4 as uuidv4} from "uuid";

import SliderNavDrawer from './NavBar/SliderNavDrawer';
import UserNavBar from './NavBar/UserNavBar';
import assets from 'src/assets';
import MenuButtons from './NavBar/MenuButtons';

/**
 * @function MenuAppBar
 * @description Barra de menu superior
 * @returns {React.JSX.Element}
 */
function MenuAppBar(): React.JSX.Element {

  return (
    <>
      <AppBar
        key={uuidv4()}
        position="static"
        sx={{
          userSelect: "none",
          zIndex: (theme: any) => theme.zIndex.drawer + 1
        }}
      >
        <Toolbar key={uuidv4()}>
          <Typography variant="h6" component="div" sx={{ mr: 2, flexGrow: 1 }} key={uuidv4()} >
            <img
              src={assets.images.techintIcon}
              alt="TECHINT"
              loading="lazy"
              style={{
                maxHeight: '1.8rem',
                verticalAlign: 'middle',
                margin: 0,
                padding: 0
              }}
            />
            <SliderNavDrawer key={uuidv4()} />
          </Typography>

          <Box sx={{ flexGrow: 1 }}></Box>

          <div>
            <MenuButtons />
            <UserNavBar
              key={uuidv4()}
              settings={
                [
                  {
                    name: 'Settings',
                    url: '/user',
                    icon: <SettingsIcon sx={{ fontSize: 16 }} key={uuidv4()} />
                  },
                  {
                    name: 'Help',
                    url: '/',
                    divider: true
                  }
                ]
              }
            />
          </div>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default MenuAppBar;
